const t={test:t=>"auto"===t,parse:t=>t};export{t as auto};
